import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';

import { User } from 'src/app/model/user';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';

@Injectable({ providedIn: 'root' })
export class AdminServiceLocal {
  public getRoles(): Observable<any> {
    const res = {
      "count": 2,
      "result": 0,
      "error_code": 0,
      "manageRoles": [
        "role_name_1",
        "role_name_2"
      ]
    };
    return of(res);
  }

  public searchUsers(user: User, roleName: string): Observable<any> {
    const res = {
      "result": 0,
      "error_code": 0,
      "count": 10,
      "userList": [
        {
          "firstName": "Alan",
          "lastName": "Doe",
          "displayName": "Alan Doe",
          "email": "alan.doe@ontario.ca",
          "roleStatus": "0",
          "accountStatus": "0"
        },
        {
          "firstName": "John",
          "lastName": "Smith",
          "displayName": "John Smith",
          "email": "john.smith@ontario.ca",
          "roleStatus": "0",
          "accountStatus": "1"
        },
        {
          "firstName": "David",
          "lastName": "Li",
          "displayName": "David Li",
          "email": "david.li@ontario.ca",
          "roleStatus": "0",
          "accountStatus": "2"
        },
        {
          "firstName": "Jessica",
          "lastName": "Sun",
          "displayName": "Jessica Sun",
          "email": "jessica.sun@ontario.ca",
          "roleStatus": "0",
          "accountStatus": "0"
        },
        {
          "firstName": "Praveen",
          "lastName": "Pathlawath",
          "displayName": "Praveen Pathlawath",
          "email": "praveen.pathlawath@ontario.ca",
          "roleStatus": "1",
          "accountStatus": "1"
        },
        {
          "firstName": "Patel",
          "lastName": "Gans",
          "displayName": "Patel Gans",
          "email": "patel.gans@ontario.ca",
          "roleStatus": "1",
          "accountStatus": "2"
        },
        {
          "firstName": "Trevor",
          "lastName": "Keldo",
          "displayName": "Trevor Keldo",
          "email": "trevor.keldo@ontario.ca",
          "roleStatus": "1",
          "accountStatus": "0"
        },
        {
          "firstName": "Laura",
          "lastName": "Sun",
          "displayName": "Laura Sun",
          "email": "laura.sun@ontario.ca",
          "roleStatus": "1",
          "accountStatus": "1"
        },
        {
          "firstName": "Santosh",
          "lastName": "Satkar",
          "displayName": "Santosh Satkar",
          "email": "santosh.satkar@ontario.ca",
          "roleStatus": "1",
          "accountStatus": "2"
        },
        {
          "firstName": "Harmeet",
          "lastName": "Choudhary",
          "displayName": "Harmeet Choudhary",
          "email": "harmeet.choudhary@ontario.ca",
          "roleStatus": "0",
          "accountStatus": "999"
        }
      ]
    };
    return of(res);
  }

  public getUserRoleDetails(userRole: UserRoleDetails): Observable<any> {
    const res = {
      "result": 0,
      "error_code": 0,
      "firstName": "Alan",
      "lastName": "Doe",
      "displayName": "Alan Doe",
      "email": "a.doe@ontario.ca",
      "roleAssigned": "0",
      "accountStatus": "1",
      "guid": "1234-1b34-2234-aecd-1123",
      "creationDate": "2022/02/21",
      "otherRoles": [
        "DDSB_DMRV_USER",
        "DDSB_DMRV_PPE_USER"
      ],
      "emailValidated": "0",
      "roleAssignmentEmail": 1,
    };
    return of(res);
  }

  public updateUserRole(userRole: UserRoleDetails): Observable<any> {
    const res = { result: 0, error_code: 0 };
    return of(res);
  }


  public sendWelcomeEmail(userRole: UserRoleDetails): Observable<any> {
    const res = { result: 0, error_code: 0 };
    return of(res);
  }

  public resetWINAttempts(email: string): Observable<any> {
    const res = { result: 0, error_code: 0 };
    return of(res);
  }

  public resetPassword(email: string, operation: number, emailAccess: number): Observable<any> {
    const res = { result: 0, operation: 1, error_code: 0, code: "Welcome@1234!"};
    return of(res);
  }

  public setEmailAccess(email: string, operation: number): Observable<any> {
    const res = { result: 0, error_code: 0};
    return of(res);
  }
  
  public sendVerificationEmail(email: string): Observable<any> {
    const res = { result: 1, error_code: 0};
    return of(res);
  }
}
